// VIP One MNET v2 questionnaire fixture — the draft 227-question template plus
// its generated chart bindings. In v2 the runtime source of truth is the
// tenant database (outbound_questionnaire_template_versions.chart_bindings,
// seeded per tenant by tools/runtime/seed-preop-questionnaire-v2.mjs); this
// module exists for the local workbench scaffold, generators and checks.

import {
  vipOneMnetV2BindingsData,
  vipOneMnetV2TemplateData,
} from "./vip-one-mnet-v2-data.js";

import type { ClinicianWorkbenchQuestionnaireFieldBinding } from "./clinician-workbench-contract.js";
import type { TenantAdminOutboundQuestionnaireQuestionV1 } from "./tenant-admin-outbound-calls-contract.js";

export interface VipOneMnetV2Template {
  templateKey: string;
  displayName: string;
  version: {
    versionLabel: string;
    questions: TenantAdminOutboundQuestionnaireQuestionV1[];
  };
}

export const vipOneMnetV2Template =
  vipOneMnetV2TemplateData as VipOneMnetV2Template;

export const vipOneMnetV2Bindings = (
  vipOneMnetV2BindingsData as {
    bindings: ClinicianWorkbenchQuestionnaireFieldBinding[];
  }
).bindings;
